import { render, staticRenderFns } from "./UserReplacePassword.vue?vue&type=template&id=b22da63a"
import script from "./UserReplacePassword.vue?vue&type=script&lang=js"
export * from "./UserReplacePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports